/**
 * 静的ファイル生成用 : カテゴリトップ用
 * Webpackで変換を行う対象
 */

import { Provider } from 'react-redux';
import { hydrateRoot } from 'react-dom/client';
import PageView from '../common/containers/modules/PageView';

import { enableAccessiBilityCheckOnDevelopment } from '../../common/accessibility/reactAxe';
import SearchBox from '../common/containers/modules/SearchBox';
import { NewsWebThemeProvider } from '../../styles/theme';
import CategoryContents from './containers/CategoryContents';
import createStore from './store';

enableAccessiBilityCheckOnDevelopment();

// SSR時にstate情報を__PRELOADED_STATE__に記述しているので読み込む
const preloadedState = window.__PRELOADED_STATE__;
const store = createStore(preloadedState);
delete window.__PRELOADED_STATE__;

// コンテンツ部分
const contentsContainer = document.getElementById('contents')!;
hydrateRoot(
  contentsContainer,
  <Provider store={store} serverState={preloadedState}>
    <NewsWebThemeProvider>
      <CategoryContents />
    </NewsWebThemeProvider>
  </Provider>
);

// 検索窓サジェスト
const searchBoxContainer = document.getElementById('searchBoxWrap-header')!;
hydrateRoot(
  searchBoxContainer,
  <Provider store={store} serverState={preloadedState}>
    <NewsWebThemeProvider>
      <SearchBox />
    </NewsWebThemeProvider>
  </Provider>
);

// ロガー部分
const loggerContainer = document.getElementById('logger')!;
hydrateRoot(
  loggerContainer,
  <Provider store={store} serverState={preloadedState}>
    <NewsWebThemeProvider>
      <PageView />
    </NewsWebThemeProvider>
  </Provider>
);
